import axios from 'axios';

const authApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 8000,
});

/**
 * Fa il refresh del token tramite l'endpoint del backend
 * @param {string} refreshToken - Il refresh token di Keycloak
 * @returns {Promise} Ritorna i nuovi token (access_token, refresh_token, expires_in)
 */
export async function refreshAccessToken(refreshToken) {
  try {
    const response = await authApi.post('/api/v1/auth/refresh-token/', {
      refresh_token: refreshToken,
    });
    return response.data;
  } catch (error) {
    // DELIBERATE: forceReauth() is not called here.
    // If /api/v1/auth/refresh-token/ fails, the existing (expired) token is used for the original
    // request. The resulting server 401 will trigger `forceReauth()`. This avoids a double-logout
    // race and keeps the refresh path outside the request interceptor recursion boundary.
    // (FR-6.1, FR-6.2)
    console.error('Failed to refresh token:', error);
    throw error;
  }
}

export default authApi;
